import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surveyimport-edit',
  templateUrl: './surveyimport-edit.component.html',
  styleUrls: ['./surveyimport-edit.component.css']
})
export class SurveyimportEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
